export function saltarBeneficiarios(observations) {
  return observations && false;
}

export function planType(observations) {

  console.log(observations);
  if (observations.includes("GT01")) {
    return ["V"];
  }
  if (observations.includes("GT02")) {
    return ["V", "D"];
  }
  if (observations.includes("GT03")) {
    return ["V", "D", "A"];
  }
  if (observations.includes("GT04")) {
    return ["V", "A"];
  }
  if (observations.includes("GT05")) {
    return ["A"];
  }

  return [];
}
